module.exports = __webpack_public_path__ + "img/phone.062fc212.svg";